import { Body1 } from '@sainsburys-tech/fable'
import React from 'react'

interface IBanner {
  message: string
  icon: JSX.Element
  className: string
  messageObject?: JSX.Element
}

const Banner = ({ message, icon, className, messageObject }: IBanner) => (
  <div className={`c-common-banner ${className}`} role='status'>
    <div className='c-common-banner__inner'>
      <span className='c-common-banner__icon'>{icon}</span>
      <span className='c-common-banner__message'>
        <Body1>{messageObject !== undefined ? messageObject : message}</Body1>
      </span>
    </div>
  </div>
)

export default Banner
